import type { SaveState } from "./saveState";

const saveStateLabel = (state: SaveState): string => {
  switch (state) {
    case "saving":
      return "Saving…";
    case "unsaved":
      return "Unsaved";
    case "stalled":
      return "Couldn't save";
    case "saved":
      return "Saved";
    case "idle":
      return "";
  }
};

// The width is reserved so a label appearing does not shift the buttons beside it.
const LAYOUT = "ml-2 inline-flex h-5 min-w-[64px] items-center justify-center rounded px-1 text-xs";

const TONE_CLASSES: Record<"onPrimary" | "light", string> = {
  onPrimary: "text-primary-foreground/80",
  light: "text-gray-500",
};

export const SaveStateBadge = ({ state, tone }: { state: SaveState; tone: keyof typeof TONE_CLASSES }) => (
  <span className={`${LAYOUT} ${TONE_CLASSES[tone]}`}>{saveStateLabel(state)}</span>
);
